<template>
  <div>

    <div v-show="showPopup.remove" class="sweet-alert showSweetAlert visible" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <div class="sa-icon sa-info" style="display: block;"></div>
      <h2>Confirmation</h2>
      <p class="lead text-muted text-left" v-if="preconizationToRemove">
        Etes-vous sûr de vouloir supprimer la préconisation d'action « {{preconizationToRemove.name}} » ?
      </p>
      <div class="sa-button-container">
        <button class="cancel btn btn-lg btn-default btn-danger" v-on:click="showPopup.remove=false">Annuler</button>
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="removePreconizationAction(preconizationToRemove.id)">Oui</button>
        </div>
      </div>
    </div>

    <div v-show="showPopup.actions" class="sweet-alert showSweetAlert visible popup_actions" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <h2>Détail des actions de la préconisation <span v-if="preconizationToShow">{{preconizationToShow.title}}</span></h2>

      <div class="row" v-if="preconizationToShow">
        <div class="col-xs-12 mt-30 mb-30">
          {{preconizationToShow.columns.length}}
          <!-- <list :container="table-parent2" :columns="preconizationToShow.columns" :dataSet="preconizationToShow.dataSet"></list> -->
        </div>
      </div>

      <div class="sa-button-container">
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="showPopup.actions = false;preconizationToShow = null">Ok</button>
        </div>
      </div>
    </div>

    <div class="col-xs-12 mt-30 mb-30">

      <list :columns="columns" :dataSet="dataSet"></list>

      <router-link :to="{name:'quizzes_preconizations_create_action'}" class="btn btn-circle green mt-20">
        <i class="fa fa-plus"></i>
         Nouvelle préconisation
      </router-link>

      <router-link :to="{name:'quizzes_preconizations_show_actions',params:{slug:$route.params.slug}}" class="btn btn-circle yellow mt-20">
        <i class="fa fa-list"></i>
         Voir en détail
      </router-link>

    </div>



  </div>
</template>

<script>

  import List from '../../others/list.vue'
  import quizzes from '../../../requests/quizzes.js'

  export default {
    created () {
    },
    components: {
      List
    },
    props: ["quiz"],
    data(){
      return{
        dataSet:[],
        columns:[],
        showPopup:{
          remove:false,
          actions:false
        },
        preconizationToRemove:null,
        preconizationToShow:null
      }
    },
    mounted:function(){
      this.getData();
    },
    methods:{
      removePreconizationAction(id){
        var parent = this;
        quizzes.removePreconizationById(this,this.$route.params.slug,id,function(err){
          if(err){
            toastr.error("Impossible de supprimer la préconisation.","ERREUR");
          }
          else{
            parent.getData();
            toastr.success("La préconisation a bien été supprimée.");
          }
          parent.showPopup.remove = false;
          parent.preconizationToRemove = null;
        })
      },
      showData(preconizations){
        var parent = this;
        parent.dataSet = [];
        for(var a=0;a<preconizations.length;a++){
            var tr = [];
            tr.push(preconizations[a].number);
            tr.push(preconizations[a].title);
            tr.push(preconizations[a].description);
            tr.push(preconizations[a].actions.length);
            // tr.push(preconizations[a].deadline);
            // var actions = '<a data-index="'+a+'" class="btn btn-default btn-circle text-right ml-5 btn_table btn_show_actions"><i class="icon-eye"></i></a>';
            var actions = '<a data-route-name="quizzes_preconizations_edit_action" data-slug="'+parent.$route.params.slug+'" data-id="'+preconizations[a].id+'" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-note"></i></a>';
            actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_remove" data-index="'+a+'"><i class="icon-trash"></i></a>';
            tr.push(actions)


            parent.dataSet.push(tr);
        }

        $(document).off('click','.btn_perso');
        $(document).on('click', '.btn_perso', function () {
            parent.$router.push({name:this.getAttribute("data-route-name"),params:{slug:this.getAttribute("data-slug"),id:this.getAttribute("data-id")}})
        });

        $(document).off('click','.btn_remove');
        $(document).on('click', '.btn_remove', function () {
            parent.showPopup.remove = true;
            parent.preconizationToRemove = preconizations[this.getAttribute("data-index")];
        });

        parent.columns = [];
        parent.columns.push({title:"N°"});
        parent.columns.push({title:"Titre"});
        parent.columns.push({title:"Description"});
        parent.columns.push({title:"Nombre d'actions"});
        // parent.columns.push({title:"Délai de réalisation"});
        parent.columns.push({title:"Actions","searchable": false,"orderable": false,class:"text-right"});

      },
      getData(){
        var parent = this;
        quizzes.getPreconizations(this,this.$route.params.slug,function(preconizations,err){
          if(preconizations){
            parent.showData(preconizations);
          }
          else{
            toastr.error("Impossible de récupérer les préconisations du questionnaire.","ERREUR");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .popup_actions{
    width:50%;
    left: 45%;
  }
</style>
<style src="../../../assets/theme/css/error.min.css"></style>



// WEBPACK FOOTER //
// list.vue?c957898a